// extracted by mini-css-extract-plugin
export var emptyState = "_5o-d";
export var statCard = "_5o-c";
export var table = "_5o-0";
export var tableCell = "_5o-4";
export var tableCellClickable = "_5o-5 _5o-4";
export var tableCellDefault = "_5o-6 _5o-4";
export var tableCellEmpty = "_5o-8";
export var tableCellWithValue = "_5o-7";
export var tableContainer = "_5o-e";
export var tableHeaderWeight = "_5o-1";
export var tableHeaderZone = "_5o-2";
export var tableRowHeader = "_5o-3";
export var viewModeButton = "_5o-9";
export var viewModeButtonActive = "_5o-a _5o-9";
export var viewModeButtonInactive = "_5o-b _5o-9";